import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/ambassador-gifts")({
  component: lazyRouteComponent(() => import("./-pages/admin.ambassador-gifts")),
  head: () => ({ meta: [{ title: "Admin · Ambassador Gifts — Lecmo" }] }),
});
